import { render } from "./ProductInfoTabs.vue?vue&type=template&id=cb768dca"
import script from "./ProductInfoTabs.vue?vue&type=script&lang=js"
export * from "./ProductInfoTabs.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__